module.exports = __webpack_public_path__ + "static/media/section-2.6233aa7b.jpg";